<app-page-header></app-page-header>
<div class="row">
  <div class="col-lg-6 offset-lg-3">
    <div class="card">
      <div class="card-header">Verify your Identity</div>
      <div class="card-body">
        <div class="text-center mb-3">Enter the 6-digit code sent to {{masked_user_email}}</div>
        <form [formGroup]="otpForm" class="d-flex gap-2 justify-content-center">
            <div class="col-auto" *ngFor="let key of controls; let i = index">
              <input
                type="text"
                maxlength="1"
                class="form-control text-center otp-input"
                [formControlName]="key.toString()"
                (input)="onInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="onPaste($event)"
              />
            </div>
          </form>
          <div class="text-center mb-3">
            <button kendoButton [primary]="true" [disabled]="otpForm.invalid" (click)="verify_otp()"> Verify your code</button>
          </div>
          <div class="text-center mb-3">Your verification code expires in {{(otp_ttl_seconds / 60) | number:'1.0-0' }} mins</div>
          <div class="text-center">
            <button class="btn btn-link" *ngIf="canResend" (click)="resend_otp_details()">
              Resend your code
            </button>
            <div *ngIf="!canResend" class="text-muted">
              Didn't receive the code? <span class="resend-timer">You can resend it in :{{ timerValue }}s</span>
            </div>
          </div>
          <nexus-form-result [model]="form_result"></nexus-form-result>

      </div>
    </div>
  </div>

</div>


